// Converts a Unix timestamp to ICS date format: YYYYMMDDTHHmmssZ
const formatDateToICS = timestamp => new Date(timestamp).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
export function generateICSContent({
  title,
  description,
  startTime,
  endTime,
  location
}) {
  return ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//HubSpot//Academy//EN', 'BEGIN:VEVENT', `DTSTART:${formatDateToICS(startTime)}`, `DTEND:${formatDateToICS(endTime)}`, `SUMMARY:${title}`, `DESCRIPTION:${description}`, location ? `LOCATION:${location}` : '', `UID:${crypto.randomUUID()}@hubspot.com`, 'END:VEVENT', 'END:VCALENDAR'].filter(Boolean).join('\r\n');
}
export function downloadICSFile(content, filename) {
  const blob = new Blob([content], {
    type: 'text/calendar;charset=utf-8'
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}